<!-- components/Header.vue -->
<template>
  <nav class="header">
    <div class="header-content">
      <router-link to="/" class="logo-link">
        <h1 class="logo">Drückerei Koch</h1>
      </router-link>

      <div class="nav-links">
        <router-link
            to="/"
            class="nav-link"
            active-class=""
            exact-active-class="active"
        >
          <i class="fas fa-house"></i>
          Start
        </router-link>

        <router-link
            to="/druckplannung"
            class="nav-link"
            active-class="active"
        >
          <i class="fas fa-users"></i>
          Kapazitätsplanung
        </router-link>

        <router-link
            to="/auftraege"
            class="nav-link"
            active-class="active"
        >
          <i class="fas fa-clipboard-list"></i>
          Aufträge
        </router-link>

        <router-link
            to="/papierbestellungen"
            class="nav-link"
            active-class="active"
        >
          <i class="fas fa-clipboard-list"></i>
          Papierbestellungen
        </router-link>


        <router-link
            to="/kunden"
            class="nav-link"
            active-class="active"
        >
          <i class="fas fa-users"></i>
          Kunden
        </router-link>

        <router-link
            v-if="can('admin')"
            to="/mitarbeiter"
            class="nav-link"
            active-class="active"
        >
          <i class="fas fa-user-tie"></i>
          Mitarbeiter
        </router-link>



        <router-link
            to="/delivery"
            class="nav-link"
            active-class="active"
        >
          <i class="fas fa-truck"></i>
          Versand
        </router-link>

        <router-link
            to="/abholliste"
            class="nav-link"
            active-class="active"
        >
          <i class="fas fa-dolly"></i>
          Abholliste
        </router-link>

        <router-link
            v-if="can('manage_users')"
            to="/projectmanagement"
            class="nav-link"
            active-class="active"
        >
          <i class="fas fa-diagram-project"></i>
          Projektverwaltung
        </router-link>

        <router-link
            v-if="can('admin_machines')"
            to="/admin/machines"
            class="nav-link"
            active-class="active"
        >
          <i class="fas fa-gears"></i>
          Maschinen
        </router-link>
      </div>

      <div class="auth-cluster">
        <router-link v-if="user" to="/ich" class="user-pill" active-class="active">
          <span class="user-pill-label">Angemeldet als:</span>
          <span class="user-pill-name">{{ userName }}</span>
          <user-avatar
              :src="user.icon_url || user.avatar_url"
              :seed="user.id"
              :name="userName"
              :size="28"
              :rounded="true"
          />
        </router-link>
        <button @click="handleLogout" class="logout-btn">
          <i class="fas fa-sign-out-alt"></i>
          Abmelden
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'Header',

  components: { UserAvatar },

  computed: {
    ...mapGetters(['user', 'can']),

    userName() {
      const u = this.user || {};
      const full = `${u.vorname || ''} ${u.nachname || ''}`.trim();
      return full || u.name || u.email || '';
    }
  },

  created() {
    // Simple check - if no user, logout
    if (!this.user) {
      this.handleLogout();
    }
  },

  methods: {
    ...mapActions(['logout']),

    handleLogout() {
      // Clear auth state
      this.logout();

      // Force redirect to login
      window.location.href = '/login';
    }
  }
}
</script>

<style scoped>
.header {
  background: #000;
  color: #fff;
  padding: 0 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-family: 'Inter', sans-serif;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  min-height: 70px;
  /* Wrap instead of forcing the document wider than the viewport — the
     single-row nav is ~1600px wide and otherwise overflows laptop screens,
     scrolling the whole page and leaving empty space on the right. */
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
}

.logo-link {
  text-decoration: none;
  color: inherit;
}

.logo {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.5px;
  color: #fff;
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  margin-left: 2rem;
  font-size: 0.9rem;
}

.user-label {
  color: rgba(255, 255, 255, 0.7);
  margin-right: 0.5rem;
}

.user-name {
  font-weight: 500;
  color: #fff;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nav-links {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.55rem 0.7rem;
  color: #fff;
  text-decoration: none;
  font-weight: 400;
  font-size: 0.9rem;
  white-space: nowrap;
  border-radius: 6px;
  transition: all 0.2s ease;
  position: relative;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.nav-link.active {
  background: #fff;
  color: #000;
  font-weight: 500;
}

.nav-link i {
  font-size: 1rem;
}

.auth-cluster {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.user-pill {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.6rem 0.4rem 0.85rem;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 9999px;
  color: #fff;
  text-decoration: none;
  font-size: 0.85rem;
  transition: all 0.2s ease;
}

.user-pill:hover, .user-pill.active {
  background: rgba(255,255,255,0.16);
  border-color: rgba(255,255,255,0.32);
  color: #fff;
}

.user-pill-label {
  color: rgba(255,255,255,0.65);
}

.user-pill-name {
  font-weight: 500;
  color: #fff;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.logout-btn {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    height: auto;
    padding: 1rem 0;
    gap: 1rem;
  }

  .user-info {
    margin-left: 0;
    margin-bottom: 0.5rem;
  }

  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
  }

  .nav-link {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }
}
</style>